import { InjectionToken, Provider } from '@angular/core';
import { AiAssistantConfig } from './interfaces/config.interface';
import { AI_ASSISTANT_CONFIG_TOKEN } from './tokens';

/**
 * Wires an application's AI assistant configuration into the library.
 *
 * Must be registered in the application ROOT providers (app config or root module):
 * the library's services and config-derived tokens are root-provided, so a config
 * alias registered in a lazy injector is invisible to them.
 */
export function provideAiAssistant(config: InjectionToken<AiAssistantConfig>): Provider[] {
  return [{ provide: AI_ASSISTANT_CONFIG_TOKEN, useExisting: config }];
}
